import { render } from "./OnboardingBoard.vue?vue&type=template&id=e761301c&scoped=true"
import script from "./OnboardingBoard.vue?vue&type=script&lang=js"
export * from "./OnboardingBoard.vue?vue&type=script&lang=js"

import "./OnboardingBoard.vue?vue&type=style&index=0&id=e761301c&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e761301c"]])

export default __exports__